import { useState, useCallback } from 'react';
import { CreatePageStepsEnum } from '../components/ItemCreationForm/types';
import { CompanyTargetTypeEnum } from '../graphql/types';

interface Context {
  profile?: { targetType?: CompanyTargetTypeEnum };
}

const STEP_ORDER = [
  CreatePageStepsEnum.DealType,
  CreatePageStepsEnum.PropertyType,
  CreatePageStepsEnum.OwnerType,
  CreatePageStepsEnum.Form
];

export const useCreationFormStepFlow = <TContext extends Context>(
  ctx: TContext
) => {
  const [pageStep, setPageStep] = useState<CreatePageStepsEnum>(
    CreatePageStepsEnum.DealType
  );

  const shouldSkipStep = useCallback(
    (step: CreatePageStepsEnum): boolean => {
      switch (step) {
        case CreatePageStepsEnum.OwnerType:
          return (
            ctx.profile?.targetType === CompanyTargetTypeEnum.Agency ||
            ctx.profile?.targetType === CompanyTargetTypeEnum.Residence
          );
        default:
          return false;
      }
    },
    [ctx]
  );

  const goNext = useCallback(() => {
    const currentIndex = STEP_ORDER.indexOf(pageStep);
    const nextSteps = STEP_ORDER.slice(currentIndex + 1);
    const next = nextSteps.find(step => !shouldSkipStep(step));

    if (next) setPageStep(next);
  }, [pageStep, shouldSkipStep]);

  return {
    pageStep,
    setPageStep,
    goNext
  };
};
